<template>
  <div class="ai-assistant-button dropdown" :class="{'active': showDropdown}">
    <button
      class="btn btn-lg btn-primary ai-assistant-btn"
      :disabled="!isEnabled"
      @click="toggleDropdown"
    >
      <!-- eslint-disable max-len -->
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" fill="none" class="ai-icon">
        <path fill="currentColor" d="m14.217 5.667.658-1.459 1.458-.658a.417.417 0 0 0 0-.758l-1.458-.659-.658-1.466a.417.417 0 0 0-.759 0L12.8 2.125l-1.467.658a.417.417 0 0 0 0 .759l1.459.658.658 1.467c.15.325.617.325.767 0m-6.634 1.25L6.258 4c-.291-.65-1.225-.65-1.516 0L3.417 6.917.5 8.242c-.65.3-.65 1.225 0 1.516l2.917 1.325L4.742 14c.3.65 1.225.65 1.516 0l1.325-2.917L10.5 9.758c.65-.3.65-1.225 0-1.516zm5.867 5.416-.658 1.459-1.459.658a.417.417 0 0 0 0 .758l1.459.659.658 1.466c.15.325.608.325.758 0l.659-1.458 1.466-.658a.417.417 0 0 0 0-.759l-1.458-.658-.658-1.467a.423.423 0 0 0-.767 0"></path>
      </svg>
      <!-- eslint-enable max-len -->
      Assistente IA
      <fa-icon :icon="['fal', showDropdown ? 'chevron-up' : 'chevron-down']" class="ml-1" />
    </button>
    <div class="menu ai-dropdown-menu" v-if="showDropdown">
      <div class="menu-header">
        <h6>Assistentes de IA</h6>
      </div>
      <div class="menu-body">
        <div class="assistants-list">
          <button
            class="assistant-option"
            @click="selectAssistant('noa-notes')"
          >
            <div class="assistant-icon">
              <!-- eslint-disable max-len -->
              <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M45.6,18.7,41,14.9V7.5a1,1,0,0,0-.6-.9L30.5,2.1h-.4l-.6.2L24,5.9,18.5,2.2,17.9,2h-.4L7.6,6.6a1,1,0,0,0-.6.9v7.4L2.4,18.7a.8.8,0,0,0-.4.8v9H2a.8.8,0,0,0,.4.8L7,33.1v7.4a1,1,0,0,0,.6.9l9.9,4.5h.4l.6-.2L24,42.1l5.5,3.7.6.2h.4l9.9-4.5a1,1,0,0,0,.6-.9V33.1l4.6-3.8a.8.8,0,0,0,.4-.7V19.4h0A.8.8,0,0,0,45.6,18.7Zm-5.1,6.8H42v1.6l-3.5,2.8-.4.3-.4-.2a1.4,1.4,0,0,0-2,.7,1.5,1.5,0,0,0,.6,2l.7.3h0v5.4l-6.6,3.1-4.2-2.8-.7-.5V25.5H27a1.5,1.5,0,0,0,0-3H25.5V9.7l.7-.5,4.2-2.8L37,9.5v5.4h0l-.7.3a1.5,1.5,0,0,0-.6,2,1.4,1.4,0,0,0,1.3.9l.7-.2.4-.2.4.3L42,20.9v1.6H40.5a1.5,1.5,0,0,0,0,3ZM21,25.5h1.5V38.3l-.7.5-4.2,2.8L11,38.5V33.1h0l.7-.3a1.5,1.5,0,0,0,.6-2,1.4,1.4,0,0,0-2-.7l-.4.2-.4-.3L6,27.1V25.5H7.5a1.5,1.5,0,0,0,0-3H6V20.9l3.5-2.8.4-.3.4.2.7.2a1.4,1.4,0,0,0,1.3-.9,1.5,1.5,0,0,0-.6-2L11,15h0V9.5l6.6-3.1,4.2,2.8.7.5V22.5H21a1.5,1.5,0,0,0,0,3Z"/>
                  <path d="M13.9,9.9a1.8,1.8,0,0,0,0,2.2l2.6,2.5v2.8l-4,4v5.2l4,4v2.8l-2.6,2.5a1.8,1.8,0,0,0,0,2.2,1.5,1.5,0,0,0,1.1.4,1.5,1.5,0,0,0,1.1-.4l3.4-3.5V29.4l-4-4V22.6l4-4V13.4L16.1,9.9A1.8,1.8,0,0,0,13.9,9.9Z"/>
                  <path d="M31.5,14.6l2.6-2.5a1.8,1.8,0,0,0,0-2.2,1.8,1.8,0,0,0-2.2,0l-3.4,3.5v5.2l4,4v2.8l-4,4v5.2l3.4,3.5a1.7,1.7,0,0,0,2.2,0,1.8,1.8,0,0,0,0-2.2l-2.6-2.5V30.6l4-4V21.4l-4-4Z"/>
                </g>
              </svg>
              <!-- eslint-enable max-len -->
            </div>
            <div class="assistant-info">
              <h6>Noa Notes</h6>
              <p>Transcrição e resumo de consultas com IA</p>
            </div>
            <fa-icon :icon="['fal', 'chevron-right']" class="assistant-arrow" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isEnabled'],
  data() {
    return {
      showDropdown: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectAssistant(assistant) {
      this.$emit('assistant-selected', assistant);
      this.showDropdown = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.ai-assistant-button {
  position: relative;
  display: inline-block;

  .ai-assistant-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    .ai-icon {
      width: 1.1em;
      height: 1.1em;
      flex-shrink: 0;
    }

    .mr-1 {
      margin-right: 0.25rem;
    }

    .ml-1 {
      margin-left: 0.25rem;
      font-size: 0.75em;
    }
  }

  .ai-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: $layout-spacing;
    min-width: 400px;
    max-width: 500px;
    background: $light-color;
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: $zindex-1;

    .menu-header {
      padding: $layout-spacing-lg;
      border-bottom: $border-width solid $border-color;

      h6 {
        margin: 0;
        font-size: $font-size-lg;
        font-weight: 600;
        color: $gray-color-900;
      }
    }

    .menu-body {
      max-height: 500px;
      overflow-y: auto;

      .assistants-list {
        padding: 0;

        .assistant-option {
          display: flex;
          align-items: center;
          width: 100%;
          padding: $layout-spacing-lg;
          background: transparent;
          border: none;
          border-bottom: $border-width solid $border-color;
          cursor: pointer;
          text-align: left;
          transition: background-color 0.2s ease;

          &:hover {
            background-color: $bg-color;
          }

          &:last-child {
            border-bottom: none;
          }

          .assistant-icon {
            width: 2.5rem;
            height: 2.5rem;
            min-width: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: $purple-neon-color-100;
            border-radius: $border-radius;
            margin-right: $layout-spacing-lg;

            svg {
              width: 1.5rem;
              height: 1.5rem;
              fill: $purple-neon-color-500;
            }
          }

          .assistant-info {
            flex: 1;

            h6 {
              margin: 0 0 $layout-spacing-sm 0;
              font-size: $font-size-lg;
              font-weight: 600;
              color: $gray-color-900;
            }

            p {
              margin: 0;
              font-size: $font-size-sm;
              color: $gray-color-700;
            }
          }

          .assistant-arrow {
            color: $gray-color-600;
            font-size: 0.9em;
          }
        }
      }
    }
  }
}
</style>
